<template>
  <div class="container">
      <div class="search-bar">
      <!-- <el-button class="add-btn" icon="el-icon-plus" @click="addItem">新增</el-button> -->
      <div class="right">
        <el-autocomplete
            v-model="filterObj[currentColumObj.modelFiled]"
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, currentColumObj.keyField) }"
            clearable
            ref="autocomplete"
            v-scrollLoad="load"
            v-loading="loading"
            :trigger-on-focus="false"
            :value-key="currentColumObj.keyField"
            :placeholder="currentColumObj.placeholder"
            @select="function (item) { return handleSelect(item, currentColumObj.keyField) }"
            @keyup.enter.native="search"
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <button slot="append" class="search-btn" @click="search">{{$t('tagsView.search')}}</button>
        </el-autocomplete>
        <div class="advance-filter">
          <i class="iconfont icon-shaixuan"></i>
          <span class="title" @click="showDrawer">{{$t('complaintList.highSearch')}}</span>
        </div>
      </div>
   </div>
   <div class="main">
     <div class="action-bar">
        <div class="total" v-if="['myPayment', 'shopOrder', 'leaseDeposit', 'generalSaleMachinehourMoney', 'generalSaleMachinehour', 'generalOrder'].includes(dataCode)">
            <span class="label">{{$t('archiveManagerMachive.totalAmount')}}：</span>
            <div class="col">
            <span class="price-unit">$</span>
            <span class="price">{{ totalPrice ||0}}</span>
            </div>
        </div>
        <div class="total" v-if="['applyDevice'].includes(dataCode)">
            <span class="label">{{$t('reportIndex.installMachNum')}}：</span>
            <div class="col">
            <span class="num">{{ totalNum }}</span>
            </div>
        </div>
        <div class="total" v-if="['generalSaleMachinehourMoney', 'generalSaleMachinehour'].includes(dataCode)">
            <span class="label">{{$t('archiveManagerMachive.totalDuration')}}：</span>
            <div class="col">
            <span class="num">{{ totalHour }}</span>
            </div>
        </div>
     </div>
     <div class="list-table">
       <common-table
         :tableData="dataSource"
         :columObj="currentColumObj"
         :pageObj="listReq"
         :stripe="true"
         height="calc(70vh - 160px)"
         @switchChange="switchChange"
         @editInputBlur="editInputBlur"
         @rowClick="rowClick"
         @handleSelectionChange="handleSelectionChange"
         @handleSizeChange="handleSizeChange"
         @handleCurrentChange="handleCurrentChange">
       </common-table>
     </div>
   </div>
    <FilterDrawer
    @faction="faction"
    :defaultInfo="currentInfo"
    v-if="drawerVisible"
    :visible.sync="drawerVisible"
    />
  </div>
</template>

<script>
import commonTable from "@/components/table/index"
import FilterDrawer from "./components/filter.vue"
import { columns_ } from "./config"
  export default {
    components: {
      commonTable,
      FilterDrawer
    },
    data() {
      return {
        filterObj: {
          shopName: '', // 店铺、总代、区代名称
          itemName: '', // 商品名称
          type: '',
          buyType: '',
          startTime: '',
          endTime: '',
          areaCode: '',
          areaName: '',

          shopcode:  '',
          generalName: '',
          generalCode: ''
        },
        searchList: [],
        dataSource: [],
        deleteIds: [],
        totalPrice: '',
        totalHour: '',
        priceUnit: '',
        totalNum: '',
        currentInfo: {},
        drawerVisible: false,
        loading: false
      }
  },
  props: {
      type: {
        type: String,
        required: true
      }
    },
  computed: {
      currentType() {
        return this.type || this.$route.meta.type
      },
      listReq() {
          return {
              position: "right", //分页组件位置
              pageData: {
                  current: 1,
                  size: 20,
                  total: 0,
                  // generalCode: this.userInfo ? this.userInfo.content.generalCode : '',
                  // fuzzyShopName: this.filterObj.shopName,
                  itemName: this.filterObj.itemName,
                  type: this.filterObj.type,
                  buyType: this.filterObj.buyType,
                  beginTime: this.filterObj.startTime,
                  endTime: this.filterObj.endTime,
                  areaCode: this.filterObj.areaCode,
                  areaName: this.filterObj.areaName,
                  shopName: this.filterObj.shopName,
                  shopcode: this.filterObj.shopcode,
                  generalName: this.filterObj.generalName,
                  generalCode: this.filterObj.generalCode,
              }
          }
      },
      autoCompleteList() {
        return {
          current: 1,
          size: 10,
        }
      },
      userInfo() {
        let userInfo_ = JSON.parse(window.localStorage.getItem('saber-userInfo'));
        if(userInfo_) {
          return userInfo_;
        }
      },
      // 获取当前table设置
      currentColumObj() {
        return columns_.filter(x => x.code === this.currentType)[0].columObj;
      },
      // 获取当前table标识
      dataCode() {
         return columns_.filter(x => x.code === this.currentType)[0].code;
      }
    },
    created() {
      console.log(this.currentColumObj);
      console.log(this.dataCode);
      this.getSearchList();
      this.getList();
    },
    mounted() {
      // 挂载行操作事件到window
      window.rowOperation = () => {
        this.rowOperation;
      }
      console.log(window.rowOperation);
    },
    methods: {
        faction(e) {
          // debugger
          console.log(e,'faction');
          this.filterObj.type = e && e.type ? e.type : '';
          this.filterObj.startTime = e && e.startTime ? e.startTime : '';
          this.filterObj.endTime = e && e.endTime ? e.endTime : '';
          this.filterObj.buyType = e && e.buyType ? e.buyType : '';
          this.filterObj.areaCode = e && e.areaCode ? e.areaCode : '';
          this.filterObj.areaName = e && e.areaName ? e.areaName : '';
          this.filterObj.shopName = e && e.shopName ? e.shopName : '';
          this.filterObj.shopcode = e && e.shopcode ? e.shopcode : '';
          this.filterObj.generalName = e && e.generalName ? e.generalName : '';
          this.filterObj.generalCode = e && e.generalCode ? e.generalCode : '';
          this.getList();
        },
        showDrawer() {
          this.drawerVisible = true;
          this.currentInfo.filterObj = this.filterObj;
          this.currentInfo.formType = this.dataCode;
        },
        querySearchAsync(queryString, cb, target) {
          var searchList = this.searchList;
          console.log(searchList);
          var results = queryString ? searchList.filter(this.createStateFilter(queryString, target)) : searchList;
          console.log(results);
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 3000 * Math.random());
        },
        createStateFilter(queryString, target) {
          console.log(target);
          return (state) => {
            console.log(state);
            return (state[target].toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
        },
        load() {
           console.log(123);
           this.getSearchList();
        },
        handleSelect(item, target) {
          console.log(this.currentColumObj.selectFiled);
          console.log(target);
          this.filterObj[this.currentColumObj.selectFiled] = item[target];
          this.getList();
        },
        search() {
          this.getList();
        },
        // 操作行事件
        rowOperation(row, $index, action) {
        if(action === 'delete') {

        }
        if(action === 'edit') {
          console.log(row)
        }
        if(action === 'look') {

        }
      },
      switchChange(row, $index, prop) {
        console.log(row, $index, prop)
      },
      handleSelectionChange(val) {
        console.log(val)
        this.deleteIds = val.map(x => x.id);
        console.log(this.deleteIds)
      },
      rowClick(row, column, event) {
        console.log(row)
        // 点击行触发，编辑点击的所在列，排除selection选择框
        if (column.type != 'selection' && this.columObj.columnData[column.index].editRow === null) {
          this.columObj.columnData[column.index].editRow = row.rowIndex;
        }
      },
      editInputBlur(row, $index, prop, columIndex) {
        this.columObj.columnData[columIndex].editRow = null;
      },
      //页码变化
      handleCurrentChange(e) {
        console.log(e)
        this.listReq.pageData.current = e;
        this.getList();
      },
      //条数变化
      handleSizeChange(e) {
        this.listReq.pageData.size = e;
        this.listReq.pageData.current = 1;
        this.getList();
      },
      // 获取自动补全列表
      async getSearchList() {
        try {
          const res = await this.currentColumObj.searchApi(this.currentColumObj.searchParams ? { selectCondition: this.currentColumObj.searchParams } : this.autoCompleteList);
          console.log(res.data);
          if(res.data && res.data.code === 200) {
          let { size, current } = this.autoCompleteList;
					if (res.data.data.records && res.data.data.records.length < size) this.noMore = true; //如果响应值列表的长度小于我们所请求的页数 那就意味已经没有下一页了
					if (current === 1) this.searchList = res.data.data.records;
					//如果current是第一页，直接赋值
					else this.searchList = [...this.searchList, ...res.data.data.records]; //不是第一页 将原数组和得到的数组进行合并
          }
        } catch(e) {
          this.$message.error(e.toString());
        }
      },
      async getList() {
        try {
          this.currentColumObj.loading = true;
          console.log(this.listReq.pageData,this.filterObj, '---this.listReq.pageData')
          const res = await this.currentColumObj.listApi(this.listReq.pageData);
          console.log('res =>', res);
          if(res.data && res.data.code === 200) {
            this.dataSource = res.data.data.records ? res.data.data.records : [];
            this.listReq.pageData.total = res.data.data.total;
            this.totalPrice = res.data.data.sumPrice ? res.data.data.sumPrice : '';
            this.totalNum = res.data.data.sumNum ? res.data.data.sumNum : '';
            this.priceUnit = res.data.data.unit ? res.data.data.unit : '';
            this.totalHour = res.data.data.sumHour ? res.data.data.sumHour : '';
          }
          this.currentColumObj.loading = false;
        } catch(e) {
          this.$message.error(e.toString());
        }
      },
      toHourMinute(minutes){
        return (Math.floor(minutes / 60) + this.$t('reportIndex.hour') + (minutes % 60).toFixed(2) + this.$t('reportIndex.minute') );
        // 也可以转换为json，以方便专外部使用属
        // return {hour:Math.floor(minutes/60),minute:(minutes%60)};
      }
    },
    directives:{
      scrollLoad:{
        bind(el, binding, vnode){
            var that =this
            let wrapDom = el.querySelector(".el-autocomplete-suggestion__wrap")
            let listDom = el.querySelector(".el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list")
            wrapDom.addEventListener("scroll",(e)=>{
            let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight
            if(condition > 0 && !vnode.context.loading){
              //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法

              binding.value()
            }
          },false)
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
    background-color: #f0f2f5;
    height: 100%;
    overflow: auto;
}
.search-bar {
    display: flex;
    justify-content: flex-end;
    padding: 0 19px;
    align-items: center;
    min-height: 64px;
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
    border-radius: 4px;
    .add-btn {
        background: #50C4CB;
        color: #fff;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }
    .right {
        display: flex;
        align-items: center;
        .advance-filter {
            margin-left: 25px;
            .title {
              margin-left: 8px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
            }
        }
        .search-btn {
            background: #59CFD6;
            border: none;
            color: #fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
        }
        .advance-filter:hover {
            cursor: pointer;
            color: #59CFD6;
        }
    }
    /deep/ .el-autocomplete input {
        border-color: #59CFD6;
    }
    /deep/ .el-input-group__append {
        background-color: #59CFD6;
    }
}
.main {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px 20px;
  box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
  .action-bar {
    display: flex;
    margin-bottom: 20px;
    .total {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
    }
    .total:not(:first-child) {
        margin-left: 20px;
    }
    .label {
        color: #999999;
    }
    .col {
        flex: 1;
        color: #FD894A;
    }
  }
}
</style>
